import React from 'react';

const NotFound = () => {
    // Not found page
    return (
        <div>
            <h3>404</h3>
            <p>The page you looking for is not found</p>
        </div>
    );
};

export default NotFound;